<div class="cart-preview-card animated fadeInRight">

  <section class="d-flex justify-content-between align-items-center gap-3 position-relative">
    @if (isSkipped()) {
    <section class="skipped"></section>
    }
    <div class="cart-preview-card__img">
      <a [routerLink]="['/shop/'+(product()?.productUrl || '')]">
        <img [src]="product()?.img || 'assets/images/product-placeholder.webp'" alt="image"
          (error)="handleImageError($event)" />
      </a>
    </div>

    <div class="d-flex flex-column justify-content-center flex-grow-1 width-100 gap-2">

      <!-- Name -->
      <div class="d-flex justify-content-between align-items-start gap-2">
        <a class="title" [routerLink]="['/shop/'+(product()?.productUrl || '')]">
          {{ product().name }}
        </a>

        @if (isPreorder()) {
        <!-- DEV-11172: compact "Pre-Order" badge instead of a full-width
             notice. Info icon signals the tooltip; tooltip explains
             pre-order items can't be removed and qty can only go up. -->
        <span class="badge bg-secondary cursor-pointer d-inline-flex align-items-center gap-1 flex-shrink-0"
          [triggers]="isMobile() ? 'click' : 'hover focus'"
          [autoClose]="true"
          tabindex="0"
          role="button"
          ngbTooltip="This is a pre-order item. It can't be removed from the order, and the quantity can only be increased. Contact customer service for any other change."
          container="body">
          Pre-Order
          <i class="material-symbols-outlined" style="font-size: 0.9rem;">info</i>
        </span>
        }
      </div>

      <div class="d-flex justify-content-between align-items-center">

        <div class="cart-preview-card__content">

          <!-- Display -->
          <span class="subtitle">
            @if (product()?.variant?.attribute?.name) {
            {{product()?.variant?.attribute?.name}}: {{product()?.variant?.attribute?.value?.name}}
            } @else if (product()?.package) {
            Package: {{ product()?.package?.name }}
            }

            @if (product()?.subscription) {
            {{((product()?.package?.name || product()?.variant?.attribute?.name) ? ' | ' : '') +
            product().subscription?.frequency?.name}}
            }
          </span>

          <!-- Quantity -->
          <div class="input-plus-minus" [class.with-button]="showUpdateButton()">
            @if(allowModification()) {
            <mat-form-field class="rounded-selector d-flex" subscriptSizing="dynamic">
              @if (isMoreThanTen()) {
              <input type="text" placeholder="0" matInput appOnlyNumber [(ngModel)]="newQuantity" />
              } @else {
              <mat-select [(ngModel)]="newQuantity" (selectionChange)="onQuantityChange()">
                <!-- DEV-11172: on pre-order lines the customer can only
                     INCREASE the quantity, so anything below the current one
                     is filtered out of the dropdown.
                     DEV-11416: and nothing above the purchase limit or the stock. -->
                @for (number of quantityOptions(); track number) {
                <mat-option [value]="number" data-nav="toggleCardPreviewNav">
                  {{ number }}
                </mat-option>
                }
                @if (allowsTenOrMore()) {
                <mat-option [value]="10" data-nav="toggleCardPreviewNav">
                  10+
                </mat-option>
                }
              </mat-select>
              }
            </mat-form-field>

            @if (showUpdateButton()) {
            <button type="button" class="btn btn-secondary btn-product-action-mobile" [disabled]="!newQuantity()"
              (click)="validateQuantity()">
              Update
            </button>
            }

            } @else {
            <span class="h4-bold text-secondary-700">
              x {{ newQuantity() }}
            </span>
            }
          </div>

        </div>

        <div class="cart-preview-card__content align-items-end">

          <!-- Price -->
          @if (!isSkipped()) {
          @if (!product().bundle?.items?.length && product().bundle?.priceRange) {
          <span class="price">
            {{ product().bundle.priceRange }}
          </span>
          } @else {
          <span class="price">
            @if (hasPricelistDiscount()) {
            <span class="text-black-50 text-decoration-line-through">{{ (product()?.bundle?.items?.length ? originalTotalPrice() : originalUnitPrice()) | currency}}</span>
            <span class="text-black-50">&rarr;</span>
            }
            {{ (product()?.bundle?.items?.length ? product()?.totalPrice : product().price) | currency}}
          </span>
          }
          }

          <!-- Tag -->
          @if (showProductStatusTag) {
          <header class="d-flex justify-content-end">
            <span class="cart-preview-card__tag badge " [class.bg-info]="isSkipped()"
              [class.bg-success]="!isSkipped() && isInOrder()" [class.bg-warning]="!isSkipped() && !isInOrder()">
              {{isSkipped() ? 'Skipped' : isInOrder() ? 'In your order' : 'Not yet saved'}}
            </span>
          </header>
          } @else if(isSkipped()) {
          <header class="d-flex justify-content-end z-3">
            <span class="cart-preview-card__tag badge bg-info">
              Skipped
            </span>
          </header>
          }

        </div>

      </div>

    </div>

  </section>

  <!-- Actions -->
  @if(isPreorder()) {
  <!-- DEV-11172: pre-order items no longer need the full-width notice;
       the "Pre-Order" badge next to the product name carries the
       messaging via its tooltip. -->
  } @else {
  <section class="cart-preview-card__buttons">

    @if (isSkipped()) {
    <button type="button" class="btn btn-outline-secondary btn-product-action-mobile" (click)="unskip()">
      Unskip
    </button>
    }

    @if (!isSkipped() && isInOrder() && isSubscription()) {
    <button type="button" class="btn btn-outline-secondary btn-product-action-mobile" (click)="skip()">
      Skip
    </button>
    }

    @if(allowModification() && !isSubscription()) {
    <button type="button" class="btn btn-outline-secondary btn-product-action-mobile" (click)="prevRemoveCartProduct()">
      Delete
    </button>
    }

    @if (product()?.bundle && product()?.bundle?.items?.length) {
    <button type="button" class="btn btn-outline-secondary btn-product-action-mobile justify-self-end"
      data-bs-toggle="collapse" [attr.data-bs-target]="'#toggle_' + product().id" aria-expanded="false"
      aria-controls="collapseExample">
      What's inside
    </button>
    }

  </section>
  }

  @if (product()?.bundle && product()?.bundle?.items?.length) {
  <section class="collapse bg-primary bg-opacity-10 pt-2 rounded-4" [id]="'toggle_'+product().id">
    @for (item of product().bundle.items; track $index) {
    <div class="row d-flex justify-content-between p-3 py-1 animated fadeIn">
      <div class="col-8">
        <h6 class="h8-semibold">{{ item.name }} {{item.packageName ? (' | ' +
          item.packageName) : (item.display ? (' | ' + item.display) : '')}}</h6>
        @if (item?.presentation) {
        <small class="h7-semibold">
          {{ item.presentation.quantity }}
          {{ item.presentation.type }}
        </small>
        }
      </div>
      <div class="col-4">
        <h6 class="h8-semibold text-end">{{item.quantity}}</h6>
      </div>
    </div>
    }
  </section>

  @if(!isSkipped() && !product().bundle.isLocked) {
  <button type="button" class="btn btn-outline-secondary h6-bold btn-product-action-mobile w-100"
    (click)="goToCustomizeBox()">
    Customize Box
  </button>
  }

  }

</div>